import type React from "react"
import { Card } from "@/components/ui/card"
import { Users, Briefcase, CheckCircle } from "lucide-react"

const iconMap: { [key: string]: React.ReactNode } = {
  Users: <Users className="w-6 h-6" />,
  Briefcase: <Briefcase className="w-6 h-6" />,
  CheckCircle: <CheckCircle className="w-6 h-6" />,
}

interface StatCardsProps {
  stats: Array<{
    id: number
    label: string
    value: string
    icon: string
    trend: string
    color: string
    bgColor: string
  }>
}

export function StatCardsRow({ stats }: StatCardsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      {stats.map((stat) => (
        <Card key={stat.id} className="p-5 border border-border hover:shadow-md transition-shadow">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-sm text-muted-foreground font-medium">{stat.label}</p>
              <p className="text-2xl font-bold text-foreground mt-2">{stat.value}</p>
              <p className={`text-xs mt-2 ${stat.color} font-semibold`}>{stat.trend} from last month</p>
            </div>
            <div className={`${stat.bgColor} p-3 rounded-lg ${stat.color}`}>{iconMap[stat.icon]}</div>
          </div>
        </Card>
      ))}
    </div>
  )
}
